module.exports = __webpack_public_path__ + "img/people.ae629dca.png";